(function() {
    'use strict';

    angular
        .module('app.departamentos')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/departamentos',
                config: {
                    templateUrl: 'app/departamentos/departamentos.html',
                    controller: 'Departamentos',
                    controllerAs: 'vm',
                    title: 'Departamentos'
                }
            },
            {
                url: '/editar-departamento/:id?',
                config: {
                    templateUrl: 'app/departamentos/editarDepartamento.html',
                    controller: 'EditarDepartamento',
                    controllerAs: 'vm',
                    title: 'EditarDepartamento'
                }
            }
        ];
    }
})();
